import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { DashboardLayout } from "@/components/DashboardLayout";
import { LoadingBlock, EmptyState } from "@/components/common";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ScrollText } from "lucide-react";

export default function LogAttivita() {
  const { data, isLoading } = useQuery({ queryKey: ["admin-logs"], queryFn: async () => (await api.get("/admin/audit-logs")).data });
  const logs = data?.logs || [];
  return (
    <DashboardLayout title="Log attività">
      <div className="mb-4 flex items-center gap-2 text-sm text-[#5C6B68]"><ScrollText className="h-4 w-4 text-[#087A73]" /> Registro delle azioni tecniche e amministrative (senza dati personali sensibili).</div>
      {isLoading ? <LoadingBlock /> : logs.length === 0 ? <EmptyState title="Nessun log" /> : (
        <div className="overflow-x-auto bg-white rounded-2xl border border-[#D2E3DB]">
          <Table>
            <TableHeader><TableRow><TableHead>Azione</TableHead><TableHead>Entità</TableHead><TableHead>Data</TableHead></TableRow></TableHeader>
            <TableBody>
              {logs.map((l) => (
                <TableRow key={l.id} data-testid={`log-${l.id}`}>
                  <TableCell className="font-semibold text-[#102A2A]">{l.action}</TableCell>
                  <TableCell className="text-[#5C6B68]">{l.entity_type}</TableCell>
                  <TableCell className="text-[#5C6B68]">{new Date(l.created_at).toLocaleString("it-IT")}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </DashboardLayout>
  );
}
